import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const mollie = defineConnector({
  identifier: "mollie",
  name: "Mollie",
  tagLine: "European payment processing",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.mollie\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Mollie app",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [Mollie Dashboard](https://my.mollie.com/dashboard/developers/applications) and click **Create application**. Fill in the name and description, then note your client ID and secret.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/mollie/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Mollie account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Mollie account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://my.mollie.com/oauth2/authorize",
    tokenEndpoint: () => "https://api.mollie.com/oauth2/tokens",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.mollie.com/v2/organizations/me",
  },
});
